import { render, staticRenderFns } from "./ConsultingServices.vue?vue&type=template&id=acd1a61c&scoped=true"
import script from "./ConsultingServices.vue?vue&type=script&lang=js"
export * from "./ConsultingServices.vue?vue&type=script&lang=js"
import style0 from "./ConsultingServices.vue?vue&type=style&index=0&id=acd1a61c&prod&lang=css"
import style1 from "./ConsultingServices.vue?vue&type=style&index=1&id=acd1a61c&prod&lang=scss&scoped=true"
import style2 from "./ConsultingServices.vue?vue&type=style&index=2&id=acd1a61c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd1a61c",
  null
  
)

export default component.exports